import { Stack, Title, Card, Text, TextInput, Select, Switch, Button, Group, Divider } from '@mantine/core'
import { useState } from 'react'
import { notifications } from '@mantine/notifications'

export function Settings() {
  const [apiUrl, setApiUrl] = useState('http://localhost:8080')
  const [theme, setTheme] = useState('auto')
  const [notifications_enabled, setNotificationsEnabled] = useState(true)
  const [autoRefresh, setAutoRefresh] = useState(true)
  const [refreshInterval, setRefreshInterval] = useState('10')

  const saveSettings = () => {
    // Save to localStorage or backend
    localStorage.setItem('settings', JSON.stringify({
      apiUrl,
      theme,
      notifications: notifications_enabled,
      autoRefresh,
      refreshInterval,
    }))

    notifications.show({
      title: 'Settings saved',
      message: 'Your settings have been saved successfully',
      color: 'green',
    })
  }

  return (
    <Stack gap="lg">
      <Title order={2}>Settings</Title>

      <Card shadow="sm" p="lg" radius="md">
        <Stack gap="md">
          <div>
            <Text size="lg" fw={600} mb="md">
              General Settings
            </Text>

            <Stack gap="md">
              <TextInput
                label="API URL"
                description="RustSwarm API endpoint"
                value={apiUrl}
                onChange={(e) => setApiUrl(e.currentTarget.value)}
              />

              <Select
                label="Theme"
                description="Choose your preferred theme"
                data={[
                  { value: 'light', label: 'Light' },
                  { value: 'dark', label: 'Dark' },
                  { value: 'auto', label: 'Auto (System)' },
                ]}
                value={theme}
                onChange={(value) => setTheme(value || 'auto')}
              />

              <Switch
                label="Enable notifications"
                description="Show desktop notifications for important events"
                checked={notifications_enabled}
                onChange={(e) => setNotificationsEnabled(e.currentTarget.checked)}
              />
            </Stack>
          </div>

          <Divider />

          <div>
            <Text size="lg" fw={600} mb="md">
              Dashboard Settings
            </Text>

            <Stack gap="md">
              <Switch
                label="Auto-refresh data"
                description="Automatically refresh dashboard data"
                checked={autoRefresh}
                onChange={(e) => setAutoRefresh(e.currentTarget.checked)}
              />

              <Select
                label="Refresh interval"
                description="How often to refresh data (seconds)"
                data={[
                  { value: '5', label: '5 seconds' },
                  { value: '10', label: '10 seconds' },
                  { value: '30', label: '30 seconds' },
                  { value: '60', label: '1 minute' },
                ]}
                value={refreshInterval}
                onChange={(value) => setRefreshInterval(value || '10')}
                disabled={!autoRefresh}
              />
            </Stack>
          </div>

          <Divider />

          <div>
            <Text size="lg" fw={600} mb="md">
              Tracing Settings
            </Text>

            <Stack gap="md">
              <TextInput
                label="Trace collector endpoint"
                description="OpenTelemetry collector endpoint"
                defaultValue="http://localhost:4317"
              />

              <TextInput
                label="Sampling rate"
                description="Percentage of traces to sample (0-100)"
                defaultValue="10"
                type="number"
                min={0}
                max={100}
              />
            </Stack>
          </div>

          <Group justify="flex-end" mt="xl">
            <Button variant="default">Reset to defaults</Button>
            <Button onClick={saveSettings}>Save settings</Button>
          </Group>
        </Stack>
      </Card>
    </Stack>
  )
}